/**
 * TrialExtensionCard
 * Overview page card offering the trial extension. Renders nothing unless the
 * offer is available.
 */

import React, { useId } from "react";
import { useTranslation } from "react-i18next";
import { useTrialExtension } from "../../../hooks/useTrialExtension";
import { Button } from "../UIElements/Button";
import { Icon } from "../UIElements/Icon";

const TrialExtensionCard = ({ className = "" }) => {
  const { t } = useTranslation(["billing"]);
  const titleId = useId();
  const { available, days, daysRemaining, openBooking } = useTrialExtension();

  if (!available) return null;

  return (
    <section
      aria-labelledby={titleId}
      className={`card border-info/30 flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-6 ${className}`}
      data-testid="trial-extension-card"
    >
      <div className="flex min-w-0 items-start gap-3">
        <Icon
          name="Calendar"
          className="text-info mt-0.5 h-5 w-5 flex-shrink-0"
        />
        <div className="min-w-0">
          <h2 id={titleId} className="text-foreground text-base font-semibold">
            {t("trialExtension.title", { days })}
          </h2>
          <p className="text-muted-foreground mt-1 text-sm">
            {t("trialExtension.daysLeft", { remaining: daysRemaining })}{" "}
            {t("trialExtension.homeCardText", { days })}
          </p>
        </div>
      </div>
      <Button
        type="button"
        emphasis="solid"
        intent="brand"
        size="touch"
        className="flex-shrink-0"
        onClick={() => openBooking("overview")}
      >
        {t("trialExtension.bookCall")}
      </Button>
    </section>
  );
};

export default TrialExtensionCard;
